import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import Document from "../../entity/insurance/Document";
import axios from "axios";

const SERVICE = "service-insurance";
const STORAGE_SERVICE = "service-document-storage";
const ENTITY = "documents";

export default function () {
    const {findOneBy} = useApi();
    const state = useSelector;
    const newInstance = data => new Document(data);

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.insurance?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    return findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application");
                }
            }
        },
        async uploadFile(file) {
            try {
                const response = await axios.post(
                    process.env.REACT_APP_API_URL + `/${STORAGE_SERVICE}/uploader/${ENTITY}`,
                    file,
                    {headers: {"Content-Type": file.type || "application/octet-stream"}}
                );

                return response.data?.id ?? null;
            } catch (e) {
                console.log(e);
                return false;
            }
        }
    }
}
